module.exports = __webpack_public_path__ + "img/m4.dc81d55a.png";